import PossiblePatientItem from './PossiblePatientItem.view';

export default PossiblePatientItem;
